import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I am <span className="purple">Dhruv Bansal</span>, a{" "}
            <span className="purple">Software Engineer (SDE1)</span> at{" "}
            <span className="purple">Sopra Banking Software (SBS)</span> in
            Noida, India.
            <br />
            <br />
            I have <span className="purple">3+ years</span> of professional
            experience building scalable monolithic and microservice-based
            applications with{" "}
            <span className="purple">
              Java, Spring Boot, React.js and Docker
            </span>
            , and I completed my B.Tech in Computer Science in 2023.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Badminton
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Dhruv</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
